<template>
  <div class="animated fadeIn faster">
    <div class="userinfo">
      <div>Kallenavn: {{ username }}</div>
      <div>E-post: {{ email }}</div>
      Trykk
      <a href="#" @click="changeUser">
        her
      </a>
      for å logge ut
    </div>
    <div v-if="showRegistrationForm">
      <p class="siimple-p">
        For å bli med på konkurransen og få tilgang til oppgavene, må du skrive
        inn e-posten din og et brukernavn til high score-listen.
        Blant de med alle riktig blir det trukket en heldig vinner.🏆!
        Konkurransen avsluttes mandag <strong>1. april. kl 23:59</strong>.
      </p>
      <div class="siimple--mb-5">
        <div class="siimple-field">
          <div class="siimple-field-label">
            Din e-postadresse (ikke synlig for andre)
          </div>
          <input
            v-model="email"
            type="text"
            class="siimple-input siimple-input--fluid"
            placeholder="meg@e-post.no"
          />
          <div v-if="invalidEmail" class="siimple-field-helper">
            E-post kan ikke være tomt
          </div>
        </div>
        <div class="siimple-field">
          <div class="siimple-field-label">
            Ditt brukernavn (vises på highscore-listen)
          </div>
          <input
            v-model="username"
            type="text"
            class="siimple-input siimple-input--fluid"
            placeholder="brukernavn"
          />
          <div
            v-if="invalidUsername"
            class="siimple-field-helper validationUsername"
          >
            Brukernavn kan ikke være tomt
          </div>
        </div>
        <p class="siimple-p siimple--text-italic siimple--text-small">
          E-posten vil kun bli brukt til informasjon rundt Novanets påskenøtter:
          varslig til vinner, oppsummering av konkurranse og eventuell
          påminnelse om ny konkurranse til neste år. Etter det slettes
          e-postadressen for evig og alltid.
        </p>
        <div align="center">
          <div class="siimple-btn siimple-btn--primary" @click="registerUser">
            Start
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="showRegistrationForm">
      <signup @submit="register($event)"></signup>
    </div> -->
    <p v-if="showUserText" class="siimple-p">
      Du er med i konkurransen! Dine <span class="correct">riktige</span> svar
      blir automatisk registrert. Den som får flest riktige svar vinner et
      gavekort på Outland. Hvis det er flere med samme poengsum, trekker vi en
      tilfeldig vinner. Følg med på highscore-lista
      <router-link class="siimple-link" to="/highscores">her</router-link>.
      Lykke til!
    </p>
    <spinner v-if="showQuizzes && isLoading" />
    <div v-if="showQuizzes && !isLoading">
      <quiz-group
        v-for="(group, index) in quizgroups"
        :key="index"
        :heading="group.category"
        class="siimple--mb-5"
      >
        <quiz-item
          v-for="(quizItem, index) in group.quizItems"
          :key="index"
          :item="quizItem"
        />
      </quiz-group>
    </div>
    <div v-if="showQuizzes && !isLoading" align="center">
      Trykk
      <div class="siimple-btn siimple-btn--primary" @click="changeUser">
        her
      </div>
      for å bytte bruker
    </div>
  </div>
</template>

<script>
import Signup from '@/components/Signup';
import QuizGroup from '@/components/QuizGroup';
import QuizItem from '@/components/QuizItem';
import Spinner from '@/components/Spinner';
import HTTP from '@/utils/http-common';

export default {
  name: 'FullQuiz',
  components: {
    QuizGroup,
    QuizItem,
    Spinner,
    Signup
  },
  data() {
    return {
      quizgroups: [],
      email: '',
      username: '',
      showUserText: false,
      showQuizzes: false,
      showRegistrationForm: false,
      invalidEmail: false,
      invalidUsername: false,
      isLoading: true
    };
  },
  mounted() {
    if (localStorage) {
      this.username = localStorage.getItem('username') || '';
      this.email = localStorage.getItem('email') || '';
      if (this.username && this.email) {
        this.showRegistrationForm = false;
        this.showQuizzes = true;
        this.showUserText = false;
      } else {
        this.showRegistrationForm = true;
      }
    }
    if (this.email) {
      this.fetchQuizzes();
    }
  },
  methods: {
    fetchQuizzes() {
      HTTP.get(`quizzes/email/${this.email}`)
        .then(response => {
          this.quizgroups = response.data;
          this.isLoading = false;
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.error(e);
          this.isLoading = false;
        });
    },
    register(data) {
      this.username = data.username;
      this.email = data.email;
      this.registerUser();
    },
    registerUser() {
      this.invalidUsername = false;
      this.invalidEmail = false;
      let validationOk = true;
      if (!this.username) {
        this.invalidUsername = true;
        validationOk = false;
      }
      if (!this.email) {
        this.invalidEmail = true;
        validationOk = false;
      }
      if (!validationOk) return;

      if (localStorage) {
        localStorage.setItem('email', this.email);
        localStorage.setItem('username', this.username);
      }
      this.showQuizzes = true;
      this.showUserText = true;
      this.showRegistrationForm = false;
      this.fetchQuizzes();
      window.scrollTo(0, 0);
    },
    changeUser() {
      // eslint-disable-next-line no-alert
      const result = confirm('Dine svar er lagret. Bytt bruker?');
      if (result) {
        if (localStorage) {
          localStorage.clear();
        }
        this.username = '';
        this.email = '';
        this.showQuizzes = false;
        this.showUserText = false;
        this.showRegistrationForm = true;
      }
    }
  }
};
</script>

<style scoped>
.correct {
  color: #50e3c2;
}

.userinfo {
  position: absolute;
  padding: 1em;
  top: 0vh;
  right: 0vw;
}
</style>



// WEBPACK FOOTER //
// src/components/FullQuiz.vue